export const data = [
  {
    cid: 2,
    company: " \tBank of America Corp.",
    one: 0.0142,
    two: 0.0133,
    three: 0.0163,
    four: 0.0182,
    five: 0.0274,
  },
  {
    cid: 10,
    company: " \tBank of New York Mellon Corp.",
    one: 0.0155,
    two: 0.0168,
    three: 0.0157,
    four: 0.0249,
    five: 0.0207,
  },
  {
    cid: 13,
    company: " \tBB&T Corp.",
    one: 0.0121,
    two: 0.0171,
    three: 0.0234,
    four: 0.0186,
    five: 0.0265,
  },
  {
    cid: 11,
    company: " \tCapital One Financial Corp.",
    one: 0.0124,
    two: 0.0177,
    three: 0.0204,
    four: 0.018,
    five: 0.0226,
  },
  {
    cid: 4,
    company: " \tCitigroup Inc.",
    one: 0.0191,
    two: 0.0177,
    three: 0.0202,
    four: 0.0212,
    five: 0.0211,
  },
  {
    cid: 5,
    company: " \tGoldman Sachs Group Inc.",
    one: 0.0164,
    two: 0.0139,
    three: 0.024,
    four: 0.0245,
    five: 0.0274,
  },
  {
    cid: 15,
    company: " \tHSBC USA Inc.",
    one: 0.0135,
    two: 0.0139,
    three: 0.0171,
    four: 0.0244,
    five: 0.0205,
  },
  {
    cid: 1,
    company: " \tJPMorgan Chase & Co.",
    one: 0.0114,
    two: 0.02,
    three: 0.0197,
    four: 0.0195,
    five: 0.023,
  },
  {
    cid: 6,
    company: " \tMorgan Stanley",
    one: 0.0159,
    two: 0.0214,
    three: 0.021,
    four: 0.023,
    five: 0.0294,
  },
  {
    cid: 9,
    company: " \tPNC Financial Services Group Inc.",
    one: 0.0139,
    two: 0.0161,
    three: 0.0227,
    four: 0.0237,
    five: 0.028,
  },
  {
    cid: 12,
    company: " \tState Street Corp.",
    one: 0.0124,
    two: 0.0204,
    three: 0.0214,
    four: 0.0187,
    five: 0.0284,
  },
  {
    cid: 14,
    company: " \tSunTrust Banks Inc.",
    one: 0.0111,
    two: 0.0153,
    three: 0.0232,
    four: 0.0255,
    five: 0.0261,
  },
  {
    cid: 8,
    company: " \tTD Group US Holdings LLC",
    one: 0.0159,
    two: 0.0145,
    three: 0.0168,
    four: 0.0235,
    five: 0.0298,
  },
  {
    cid: 7,
    company: " \tU.S. Bancorp",
    one: 0.0104,
    two: 0.0195,
    three: 0.0172,
    four: 0.0214,
    five: 0.025,
  },
  {
    cid: 3,
    company: " \tWells Fargo & Co.",
    one: 0.0142,
    two: 0.0209,
    three: 0.0229,
    four: 0.0202,
    five: 0.0225,
  },
];
